import React from 'react';
import './BragBar.css';

function BragBar() {
  const logos = [
    'reference_1.jpg',
    'reference_2.jpg', 
    'reference_3.jpg',
    'reference_4.jpg',
    'reference_5.jpg',
    'reference_6.jpg',
    'reference_7.jpg',
    'reference_8.jpg',
    'reference_9.jpg',
    'reference_10.jpg'
  ];

  return (
    <div className="brag-bar">
      <div className="brag-bar-track">
        {/* Erste Reihe der Logos */}
        {logos.map((logo, index) => (
          <div key={`logo-${index}`} className="brag-bar-logo">
            <img src={`/img/${logo}`} alt={`Client Logo ${index + 1}`} />
          </div>
        ))}
        {/* Zweite Reihe für nahtlose Schleife */}
        {logos.map((logo, index) => (
          <div key={`logo-duplicate-${index}`} className="brag-bar-logo">
            <img src={`/img/${logo}`} alt={`Client Logo ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BragBar; 